// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"7073a6e3","199":"6864b826","521":"9c46b0b2","891":"e3b15102"}[chunkId] + ".chunk.css";
};